import { render } from "./BottomMenu.vue?vue&type=template&id=127ee82a"
import script from "./BottomMenu.vue?vue&type=script&lang=js"
export * from "./BottomMenu.vue?vue&type=script&lang=js"

import "./BottomMenu.vue?vue&type=style&index=0&id=127ee82a&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__